module.exports = __webpack_public_path__ + "img/MES.77a64501.jpg";